import { render, staticRenderFns } from "./FlightAppDesktop.vue?vue&type=template&id=f066685e&scoped=true"
import script from "./FlightAppDesktop.vue?vue&type=script&lang=js"
export * from "./FlightAppDesktop.vue?vue&type=script&lang=js"
import style0 from "./FlightAppDesktop.vue?vue&type=style&index=0&id=f066685e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f066685e",
  null
  
)

export default component.exports